var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import { CardFooter as DialogFooter } from 'modules/v2/dataDisplay/Card';
import { Loader } from 'modules/v2/feedback/Loader';
import { Button } from 'modules/v2/navigation/buttons';
import { Dialog } from './Dialog';
import { DialogContent } from './DialogContent';
import { DialogHeader } from './DialogHeader';
export function ConfirmDialog(props) {
    const { appearance = 'primary', loading = false, disabled = false, confirm, cancel, onConfirm, onCancel, icon, title, subtitle, children } = props, restProps = __rest(props, ["appearance", "loading", "disabled", "confirm", "cancel", "onConfirm", "onCancel", "icon", "title", "subtitle", "children"]);
    const initialFocusRef = useRef(null);
    return (<Dialog initialFocusRef={initialFocusRef} {...restProps}>
      <DialogHeader icon={icon} title={title} subtitle={subtitle} appearance={appearance === 'danger' ? 'danger' : undefined}/>

      <DialogContent>{children}</DialogContent>
      <DialogFooter>
        <Button ref={initialFocusRef} type="button" appearance="secondary" disabled={loading} onClick={onCancel}>
          {cancel}
        </Button>
        <Button disabled={loading || disabled} type="button" appearance={appearance} onClick={onConfirm}>
          {confirm}
          {loading && <Loader />}
        </Button>
      </DialogFooter>
    </Dialog>);
}
